<div class="around">
  <i class="fal fa-times close-btn" title="Đóng" (click)="close()"></i>
  <label for="" class="layer-label">Graph</label>
  <ngx-simplebar [ngStyle]="{ height: 'calc(100vh - 20px - 55px)' }">
    <div class="row">
      <div class="col-12" id="proportionOfSubBasinArea">
      </div>
      <div class="col-12" id="subBasinByDrainCapacityAtPercent">
      </div>
      <div class="col-12" id="runoffGenerated">
      </div>
      <div class="col-12" id="totalRunoff">
      </div>
    </div>
  </ngx-simplebar>
</div>
